import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgramReportingComponent } from './program-reporting.component';
import { ProgramReportingSessionsComponent } from './program-reporting-sessions/program-reporting-sessions.component';
import { ProgramReportingReportsComponent } from './program-reporting-reports/program-reporting-reports.component';
import { ProgramReportingSessionLogComponent } from './program-reporting-session-log/program-reporting-session-log.component';
import { AnalyticsModule } from '../../main/analytics/analytics.module';
import { SharedModule } from '@shared/shared.module';
import { AssessmentModule } from '@app/main/analytics/assessment/assessment.module';
import { AnalyticsLoaderModule } from '@app/main/analytics/loader-directive/loader.module';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
@NgModule({
  declarations: [
    ProgramReportingComponent,
    ProgramReportingSessionsComponent,
    ProgramReportingReportsComponent,
    ProgramReportingSessionLogComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AnalyticsModule,
    AnalyticsLoaderModule,
    Ng2GoogleChartsModule,
    AssessmentModule
  ],
  exports: [ProgramReportingComponent]
})
export class ProgramReportingModule {}
